import styled from "@emotion/styled"
import { Grid, Typography } from "@mui/material"
import * as api from "api"
import RatioElement from "common/ElementRatio"
import ResponsiveModelImage from "common/ResponsiveModelImage"
import Slider from "common/Slider"
import { memo } from "react"
import Shared from "theme/shared"
import VehiclePerformanceGauges from "./VehiclePerformanceGauges"

const Styled = {
  Wrapper: styled.div`
    margin: 70px 0;
    text-align: center;
  `,
  Header: styled(Shared.Header)`
    margin-bottom: 40px;
  `,
  Title: styled(Typography)`
    font-size: 18px;
    font-weight: bold;
    color: ${(p) => p.theme.colors.marine};
  `,
  Description: styled(Typography)`
    margin-top: 10px;
    font-size: 14px;
    font-weight: 500;
    color: ${(p) => p.theme.colors.bluishGrey};
  `,
  Grid: styled(Grid)`
    padding: 30px 10px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
  `,
  Text: styled.div`
    margin-top: auto;
  `,
}

type VehiclePerformancesDesktopProps = {
  title: string
  data: api.VehiclePerformance[]
}

const VehiclePerformancesDesktop = ({
  data,
  title,
}: VehiclePerformancesDesktopProps) => {
  return (
    <Styled.Wrapper>
      <Styled.Header>{title}</Styled.Header>
      <Slider
        prefix="performance"
        data={data}
        render={(p) => (
          <Grid container>
            <Grid item md={6}>
              {/* <RatioElement maxWidth={400} ratio={1 / 1}> */}
              <RatioElement ratio={1 / 1}>
                <ResponsiveModelImage image={p.image} imageSizes="400px" />
              </RatioElement>
            </Grid>
            <Styled.Grid item md={6}>
              <VehiclePerformanceGauges data={p} />
              <Styled.Text>
                <Styled.Title>{p.headline}</Styled.Title>
                <Styled.Description>{p.subtitle}</Styled.Description>
              </Styled.Text>
            </Styled.Grid>
          </Grid>
        )}
      />
    </Styled.Wrapper>
  )
}

export default memo(VehiclePerformancesDesktop)
